import Enterprises from "@/views/analyst/Enterprises";

export default [
    {
        path: '/analyst/enterprises',
        component: Enterprises,
        meta: {
            access: ['admin'],
        }
    },
]